// extracted by mini-css-extract-plugin
export default {"readonly":"GeneralProfile_readonly__+UA9N"};